export default __webpack_public_path__ + "static/media/OktaCoverImage.cd8f9420.jpeg";